import { generatePath } from 'react-router';
import * as Routes from 'components/Router/routes';

// Types
import { Route } from 'components/Router/types';

interface RoutesObject {
  [key: string]: any;
}

// A quick helper for making a route.
export default (route: Route | string, params?: any): string => {
  const routes = Routes as RoutesObject;

  let path;
  if (typeof route === 'string') path = routes[route].path;
  if (typeof route === 'object') path = route.path;

  return generatePath(path, params);
};
